/**
 * Image sizes for each placement: what to upload (2x, so it's sharp on phones and
 * high-resolution screens) and how it shows. Used by admin and the advertiser portal.
 */
export const WEB_PLACEMENTS = ['calculator', 'forum_feed', 'banner', 'page_banner'];
export const AD_SIZES = {
  newsletter: [{
    w: 1200,
    h: 630,
    name: 'Story image',
    shows: 'full width in the email'
  }, {
    w: 600,
    h: 500,
    name: 'Banner (image only)',
    shows: '300 × 250'
  }],
  calculator: [{
    w: 600,
    h: 500,
    name: 'Display ad',
    shows: '300 × 250 after the result'
  }],
  forum_feed: [{
    w: 640,
    h: 200,
    name: 'Feed banner',
    shows: '320 × 100 between discussions'
  }],
  banner: [{
    w: 600,
    h: 500,
    name: 'Sidebar ad',
    shows: '300 × 250'
  }, {
    w: 600,
    h: 1200,
    name: 'Tall sidebar ad',
    shows: '300 × 600'
  }],
  // In-page banner: two images, one for computers and one for phones
  page_banner: [{
    w: 1940,
    h: 500,
    name: 'Desktop banner',
    shows: '970 × 250 on computers and tablets'
  }],
  page_banner_mobile: [{
    w: 600,
    h: 500,
    name: 'Mobile banner',
    shows: '300 × 250 on phones'
  }]
};
export function sizeHint(placement) {
  if (placement === 'page_banner') {
    return 'Two images: desktop 1940 × 500 (shows at 970 × 250 on computers and tablets) and mobile 600 × 500 (shows at 300 × 250 on phones). Without a mobile image, phones show the desktop one scaled down.';
  }
  const sizes = AD_SIZES[placement];
  if (!sizes) return 'JPG, PNG or WebP.';
  return 'Upload ' + sizes.map(s => s.w + ' × ' + s.h + ' (' + s.name.toLowerCase() + ', shows at ' + s.shows + ')').join(' or ') + '.';
}

/** Resolves to a warning string if the image's shape or size doesn't suit the placement, else null. */
export function checkAdImage(url, placement) {
  const sizes = AD_SIZES[placement];
  if (!sizes || !url) return Promise.resolve(null);
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const w = img.naturalWidth;
      const h = img.naturalHeight;
      const ratio = w / h;
      const fit = sizes.find(s => Math.abs(ratio - s.w / s.h) / (s.w / s.h) <= 0.12);
      const expected = sizes.map(s => s.w + ' × ' + s.h).join(' or ');
      if (!fit) {
        resolve('This image is ' + w + ' × ' + h + ', which is the wrong shape here: it will look squashed, cropped or small. Upload ' + expected + '.');
      } else if (w < fit.w * 0.9) {
        resolve('This image is ' + w + ' × ' + h + ': the right shape, but small, so it may look blurry. ' + fit.w + ' × ' + fit.h + ' is best.');
      } else {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = url;
  });
}
flarum.reg.add('voucha-ads', 'common/adSizes', { WEB_PLACEMENTS: WEB_PLACEMENTS,AD_SIZES: AD_SIZES,sizeHint: sizeHint,checkAdImage: checkAdImage, });